import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.attachments')
  .factory('$attachments', AttachmentsObjectFactory);

/* @ngInject */
function AttachmentsObjectFactory($bringozFactory: $bringozFactory,
                                  attachmentsAPI: BringozApi,
                                  Attachments_DS: DataStoreConfig) {
  function $attachments(id: string) {
    return $bringozFactory(id, attachmentsAPI, Attachments_DS)
  }

  return $attachments;
}
